'use client'
import { useEffect, useRef } from 'react'
import Image from 'next/image'
import tailwindConfig from '@tailwind.config'
import LinkComponent from '@components/LinkComponent'
import { IoMdVideocam } from 'react-icons/io'

const LargeProjectCard = ({ project, imageWidth = 300, imageHeight = 200, includeInactive = false, newLimit, isLast, district = undefined, dictionary, lang }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(project.isLiked)
    // const { data: session } = useSession()

    const cardRef = useRef();

    // const handleLike = async () => {
    //     const isLike = await sendLike(project.id)
    //     setIsLiked((prevLike) => !prevLike)
    //     project.isLiked = !project.isLiked
    // };

    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    // useEffect(() => {
    //     if (session !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    let location = 'Pattaya'

    switch (lang) {
        case 'en':
            location = 'Pattaya'
            break;
        case 'th':
            location = 'พัทยา'
            break;
        case 'cn':
            location = '芭提雅'
            break;
        default:
            break;
    }

    // const isSmallDevice = window.innerWidth < 768;
    // const isTablet = window.innerWidth < 1024;

    return (
        <div className={`sm:w-[${imageWidth}px] w-full rounded-lg shadow-md hover:shadow-sm hover:shadow-maincolor`}
            ref={cardRef}
        
        >
            <LinkComponent
                className='w-full'
                href={'/projects/' + project.slug}
            >
                <div className='sm:w-[300px] w-full'>
                    <div className='relative'>
                        <Image
                            placeholder="blur"
                            blurDataURL={project.blur}
                            className='sm:w-[300px] w-full aspect-[4/3] rounded-t-md overflow-hidden'
                            src={project.cover ? project.cover : '/images/test.jpg'}
                            width={imageWidth}
                            height={imageHeight}
                            alt={project.slug}
                        />
                        {(project.videoUrl) ? (
                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                                {project.videoUrl ? (
                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                ) : null}
                            </div>
                        ) : null}
                        {project.isPromotion ? (
                            <div className='absolute left-2 top-2 bg-third text-light p-1 text-md rounded-md z-10'>{project.promotionTitle}</div>
                        ) : null
                        }
                    </div>
                    <div className='p-2'>
                    <div className='text-maincolor text-xl font-semibold rounded-r-md z-10 w-full sm:h-[60px] overflow-hidden'><h3 className='line-clamp-2'>{project.name}</h3></div>
                    <div className='flex flex-row w-full'>
                        {project.fromPrice && (
                            <div className='text-xl font-semibold text-third w-1/2'>{project.fromPrice}</div>
                            )}
                    </div>
                    <div className='w-full pb-1 mb-1'>
                        <p className='text-secondary text-xl'>{project.districts[0]?.subdistrictName?.[lang] ? project.districts[0]?.subdistrictName?.[lang] : project.districts[0]?.subdistrict}, {location}</p>
                    </div>
                    {/* <div className='flex flex-row w-full justify-between'>
                        <div className='flex flex-row items-center w-full'>
                            <BiArea
                                color={tailwindConfig.theme.extend.colors.secondary}
                            />
                            <span className='ml-2 text-xl text-maincolor'>{project.layouts.length} Available Layouts</span>
                        </div>
                    </div> */}
                    </div>
                </div>
            </LinkComponent >
        </div>
    )
}

export default LargeProjectCard